import cn from 'classnames/bind'
import { useTranslation } from 'react-i18next'

import { useCurrencySign } from 'app/common/components-next/currency'

import styles from './identifier-approve-info.module.scss'
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue'

const cx = cn.bind(styles)

type Props = {
  balance: number
  price: number
}

export const IdentifierApproveInfo = ({ balance, price }: Props) => {
  const { t } = useTranslation('identifiers-next')
  const currency = useCurrencySign()

  return (
    <dl className={styles.infoList}>
      <div>
        <dt>{t('identifier_entering_check_result_cost', 'Стоимость добавления')}</dt>
        <dd>{toFixedValueCurrency(price, false, currency)}</dd>
      </div>
      <div className={styles.regular}>
        <dt>{t('identifier_entering_check_result_balance', 'На вашем счету')}</dt>
        <dd className={cx({ danger: balance <= 0 })}>
          {toFixedValueCurrency(balance, false, currency)}
        </dd>
      </div>
    </dl>
  )
}
